import script from "./Tree.vue?vue&type=script&setup=true&lang=js"
export * from "./Tree.vue?vue&type=script&setup=true&lang=js"

import "./Tree.vue?vue&type=style&index=0&id=3bc44858&lang=scss&scoped=true"

import exportComponent from "/vue-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3bc44858"]])

export default __exports__